import { cn } from '@/lib/utils'
import { Card } from '@/components/ui/card'
import {
	ArrowUpRight,
	ArrowDownRight,
	Minus,
	type LucideIcon
} from 'lucide-react'

interface MetricCardProps {
	title: string
	value: string | number
	change?: number
	changeLabel?: string
	icon?: LucideIcon
	trend?: 'up' | 'down' | 'neutral'
	className?: string
	iconClassName?: string
}

export function MetricCard({
	title,
	value,
	change,
	changeLabel = 'vs 上周',
	icon: Icon,
	trend = 'neutral',
	className,
	iconClassName,
}: MetricCardProps) {
	const trendColors = {
		up: 'text-green-600 dark:text-green-400',
		down: 'text-red-600 dark:text-red-400',
		neutral: 'text-muted-foreground',
	}

	const trendIcons = {
		up: ArrowUpRight,
		down: ArrowDownRight,
		neutral: Minus,
	}

	const TrendIcon = trendIcons[trend]

	return (
		<Card className={cn(
			"relative overflow-hidden p-6 transition-all duration-200 hover:shadow-soft-md",
			className
		)}>
			{/* 背景装饰 */}
			<div className="absolute right-0 top-0 h-24 w-24 translate-x-8 -translate-y-8 rounded-full bg-gradient-to-br from-accent/10 to-transparent" />

			<div className="relative flex items-start justify-between">
				<div className="space-y-3">
					<p className="text-sm font-medium text-muted-foreground">{title}</p>
					<p className="text-3xl font-bold tracking-tight">{value}</p>
					{change !== undefined && (
						<div className="flex items-center gap-1.5">
							<span className={cn("flex items-center text-sm font-medium", trendColors[trend])}>
								<TrendIcon className="h-4 w-4 mr-0.5" />
								{Math.abs(change)}%
							</span>
							<span className="text-xs text-muted-foreground">{changeLabel}</span>
						</div>
					)}
				</div>

				{Icon && (
					<div className={cn(
						"flex h-12 w-12 items-center justify-center rounded-xl bg-muted",
						iconClassName
					)}>
						<Icon className="h-6 w-6 text-muted-foreground" />
					</div>
				)}
			</div>
		</Card>
	)
}
